<template lang="html">
  <section class="news">
    <div class="row">
      <div id='loadingmessage' style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;" v-if="loading">
          <p style="position: absolute; color: White; top: 40%; left: 40%;">
            <img src='../../assets/snakes.gif' /></p>
      </div>
     
       <div class="col-12 grid-margin" >
        <div class="card">
          <div class="card-body">
            <div class="row">
               <div class="col-md-4 big4" v-if="items != ''">
                   <enlargeable-image v-bind:src="'https://sarpatnapi.leopardtechlabs.in/u/'+items.photo" v-bind::src_large="'https://sarpatnapi.leopardtechlabs.in/u/'+items.photo">
             <img v-bind:src="'https://sarpatnapi.leopardtechlabs.in/u/'+items.photo" width="100%" height="auto">
             </enlargeable-image>
              <div class="col-md-12" v-if="items != ''">
             <b>Time of Incident:</b> {{items.timeofincident.slice(0,10)}}
            </div>
            <div class="col-md-12" v-if="items != ''">
             <b>Added By:</b> {{items.added_by.name}}
            </div>
            </div>
           <div class="col-md-8">
                <!-- <div class="col-md-12" v-if="items != ''">
                 <h4 class="card-title"><b>Location:</b> {{items.where}}</h4>
            </div>
            -->
             <div class="col-md-12">
               <div id="map"></div>
            </div>
             </div>
           
             </div>
             </div>
             </div>
             </div>
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Reply Now</h4>
                       <form class="form-sample" @submit="onSubmit">
              <div class="row">
                <div class="col-md-6">
                  <b-form-group horizontal label="Name" description="Name" label-for="input14">
                     <v-select v-model="name" :options="option"></v-select>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group description="Venomtype" horizontal label="Venon Type">
                    <b-form-select v-model="venomType" class="mb-3">
      <option value="Highly Venomous">Highly Venomous</option>
      <option value="Mildly Venomous">Mildly Venomous</option>
      <option value="Non Venomous">Non Venomous</option>
    </b-form-select>
                  </b-form-group>
                </div>
              </div>
                       <div class="row">
                              <div class="col-md-6">
                  <b-form-group description="Reply" horizontal label="Reply">
                    <b-form-input type="text" v-model="reply"></b-form-input>
                  </b-form-group>
                </div>
                    <div class="col-md-6">
                    <b-form-group horizontal label="Description">
                    <b-form-input type="text" v-model="description"></b-form-input>
                  </b-form-group>
                  </div>
                  </div>
                <hr>
                <b-button variant="primary" class="btn-fw" type="submit" style="float:right;">Reply Now</b-button>
            </form>
          </div>
          <hr>
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="js">
import axios from 'axios'
import { VueEditor } from 'vue2-editor'
import vSelect from 'vue-select'
import EnlargeableImage from '@diracleo/vue-enlargeable-image';
var marker
export default {
  name: 'news',
  props: ['id'],
  components: {
    VueEditor,
    vSelect,
    EnlargeableImage
  },
  data () {
    return {
      items: '',
      name: '',
      venomType: '',
      reply: '',
      description: '',
      snakes: [],
      loading: false,
      option: [],
      oMarker: [],
      snakes1: [],
      snakeid: '',
    }
  },
  watch: {
    name: function(){
      for(var i=0;i<this.snakes.length;i++){
        if(this.name == this.snakes1[i].name){
          this.snakeid = this.snakes1[i]._id;
        }
      }
    }
  },
  mounted: function () {
    this.getAll()
    this.getList()
  },
  methods: {
      getList () {
      this.loading = true
      axios({
        url: 'https://sarpatnapi.leopardtechlabs.in/snake/all/',
        method: 'GET',
        headers: {
                    'x-auth-token': localStorage.getItem("token")
                },
      }).then(response => {
         this.snakes1 = response.data.data
        this.snakes = response.data.data
        var temp = [];
        if(this.snakes.length > 0){
        for(var i=0;i<this.snakes.length;i++){
          var ty = this.snakes[i].name;
          temp.push(ty);
        }
        var tyz = 'Not able to identify the snake'
        temp.push(tyz);
        this.option = temp;
        }
        this.loading = false
      }).catch(e => {
        this.errors.push(e)
      })
    },
    getAll () {
      this.loading = true
       var mapCanvas = document.getElementById('map')
      var mapOptions = {
        // eslint-disable-next-line
        center: new google.maps.LatLng(10.8505, 76.2711),
        zoom: 6,
        // eslint-disable-next-line
        mapTypeId: google.maps.MapTypeId.HYBRID
      }
      var vm = this
      // eslint-disable-next-line
      vm.map = new google.maps.Map(mapCanvas, mapOptions)
      axios({
        url: 'https://sarpatnapi.leopardtechlabs.in/adminreply/',
        method: 'GET',
        params: {
          id: this.id
        },
        headers: {
                    'x-auth-token': localStorage.getItem("token")
                },
      }).then(response => {
        this.items = response.data.data
        var lat = response.data.data.where[1]
        var lon = response.data.data.where[0]
        var latlngset = new google.maps.LatLng(lon, lat)
          var iconBase = 'http://maps.google.com/mapfiles/kml/pal4/icon52.png'
          // eslint-disable-next-line
          marker = new google.maps.Marker({
            map: vm.map,
            position: latlngset,
            icon: iconBase
          })
          vm.oMarker[i] = {
            m: marker,
            c: id
          }
          var content = 'Location'
          // eslint-disable-next-line
          var infowindow = new google.maps.InfoWindow()
          // eslint-disable-next-line
          google.maps.event.addListener(marker, 'click',
            (function (marker, content, infowindow) {
              return function () {
                infowindow.setContent(content)
                infowindow.open(vm.map, marker)
              }
            })(marker, content, infowindow)
          )
        this.loading = false
      }).catch(e => {
        this.loading = false
      })
    },
    onSubmit (evt) {
      evt.preventDefault()
      this.loading = true
      axios({
        method: 'post',
        url: 'https://sarpatnapi.leopardtechlabs.in/adminreply/',
        data: {
          id: this.id,
          snake: this.snakeid,
          venomtype: this.venomType,
          reply: this.reply,
          details: this.description
        },
        headers: {
          'x-auth-token': localStorage.getItem('token')
        }
      })
        .then(response => {
          alert('Successfully Updated Data')
          this.$router.push('/identifyview')
          this.loading = false
        })
        .catch(e => {
          this.loading = false
          alert('Failed')
        })
    }
  }
}
</script>
<style scoped lang="scss">
#preview {
  display: flex;
  justify-content: center;
  align-items: center;
}

#preview img {
  width: 20%;
}
#map {
  height: 350px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
</style>


// WEBPACK FOOTER //
// src/views/forms/identifyreply.vue